<template>
    <div class="pageDiv">
        <div class="loader" v-if="$CommandSvc.isBusy()"></div>
        <v-card class="main-card">

            <v-card-text class="sponsor" v-if="hasSponsor()">
                <div class="sponsor-text">
                    <v-card-text style="width:100%;">
                        Thank you <span class="label14">{{sponsor.sponsorName}}</span> for being our sponsor in the upcoming
                        tournament at <span class="label14">{{sponsor.tournamentName}}</span> on
                        <span class="label14">{{sponsor.tournamentDate}}</span>. The
                        OKAGA club appreciate your generosity and kindness for being our sponsor.
                     </v-card-text>

                    <v-card-text>
                        <br>
                        <a v-if="tournament !== null && tournament.tournament.formatType === 'TOURNAMENT'" class="label16" @click="gotoTournament(tournament.tournament.tournamentId)">
                            Register to {{tournament !== null ? tournament.course.name : ""}}
                        </a>
                        <br>
                    </v-card-text>

                    <v-card-text>
                        <div class="loader" v-if="$CommandSvc.isBusy()"></div>
                        <img class="div-image div60" :src="$AuthSvc.getFlyerUrl()" >
                    </v-card-text>
                </div>
            </v-card-text>

            <v-card-text v-for="event in events" :key="event.eventName" >
                <v-card-text>
                    <v-card-text class="text10" v-if="event.eventType=='Announcement'">
                        <b style="color: darkred">Posted:</b> <span class="txt10">{{printTime(event.postedTime)}}</span>
                    </v-card-text>
                    
                    <span class="actionBtn" @click="remove(event.clubEventId)" v-if="$AuthSvc.isAdmin()">
                        <v-icon>mdi-delete</v-icon>
                    </span>
                    <span class="actionBtn" @click="edit(event.clubEventId)" v-if="$AuthSvc.isAdmin()">
                        <v-icon>mdi-pencil</v-icon>
                    </span>

                    <v-card-title v-if="event.title !== ''">
                        <span class="label16">{{event.title}}</span>
                    </v-card-title>
                    <div class="messageDiv">
                        <div v-if="event.formatType === 'HTML'">
                            <span class="messageText" v-html="event.message"></span>
                        </div>

                        <div v-if="event.formatType === 'TEXT'">
                            <pre class="messageText">{{event.message}}</pre>
                        </div>
                    </div>
                </v-card-text>
            </v-card-text>

            <v-card-text style="font-size:14px;">
                <br>
                To enroll, click here. <a href="https://www.okaga.org/enroll">https://www.okaga.com/enroll</a>
            </v-card-text>

        </v-card>
    </div>
</template>

<script>
import moment from 'moment';
import swal from 'sweetalert';

  export default {
    name: "home",
    data: () => ({
      loading: true,
      dfwvgaConfig: {"sponsorName": "", "tournamentName": "", "tournamentDate": ""},
      events: [],
      registerTournaments: [],
      tournament: null,
      sponsor: null
    }),
    mounted: function() {
       var _this = this;
       _this.$CommandSvc.get(_this, '/public/config/current-sponsor',
        function (data) {
           if (data !== '') {
              _this.sponsor = JSON.parse(data.configValue);
           }
        },
        function (error) {
            console.log('ERROR: ' + error);
        });

        this.loadData();
    },
    methods: {
      loadData() {
        var _this = this;
        _this.$CommandSvc.get(_this, '/public/club-events',
            function (data) {
                _this.events = data;
            },
            function (error) {
                console.log('ERROR: ' + error);
            });

        _this.$CommandSvc.get(_this, '/public/config',
            function (data) {
                _this.dfwvgaConfig = data;
            },
            function (error) {
                console.log('ERROR: ' + error);
            });

        _this.$CommandSvc.get(_this, '/public/tournaments/status/APPROVALS', function(data) {
          _this.registerTournaments = data;
          if (_this.registerTournaments.length > 0 ) {
            _this.tournament = _this.registerTournaments[0];
          }
        });
      },
      hasSponsor() {
        return (this.sponsor !== null && this.sponsor.showSponsor === 'Y');
      },
      onChange() {
        console.log("Message Type: ", this.messageType);
      },
      edit(clubEventId) {
        window.location.href = '/home-admin?id=' + clubEventId;
      },
      printTime(date) {
        return moment(date).format('ddd MMMM DD YYYY hh:mm A');
      },
      remove(id) {
        var _this = this;

        swal({
          title: "Are you sure?",
          text: "Delete this message",
          icon: "warning",
          buttons: true,
          dangerMode: true,
        })
        .then((willDelete) => {
          if (willDelete) {
            _this.axios.delete('/admin/club-events/'+id)
            .then(function (response) {
                console.log('Item DELETED ' + response.data);
                _this.loadData();
            });
          }
        });
      },
      gotoTournament(tournamentId) {
        window.location.href = "/registration?id=" + tournamentId;
      }
    },
    handleFileUpload( event ){
        this.file = event.target.files[0];
    }
  }
</script>

<style scoped>

    ul {
      list-style: square;
    }

    li {
        margin-left: 30px;
    }

    .events-card {
        margin: 3px 0 !important;
        padding: 3px !important;
    }

    .event-card {
        padding: 3px !important;
    }

    .winner-table {
        width: 100%;
    }

    .sponsor {
        margin: 5px 0;
    }

    .sponsor .sponsor-text {
        display: inline-block;
        vertical-align: top;
        padding: 5px 0;
        width: 100%;
    }
    .sponsor-text * {
        font-size: 14px;
    }
    .sponsor .image {
        padding: 5px;
    }

    img {
      width: 100%;
    }

    @media (min-width: 768px) {
        .sponsor .sponsor-text {
            display: inline-block;
            vertical-align: top;
            padding: 25px;
        }

        .sponsor .image {
            display: inline-block;
            width: 45% !important;
            padding: 25px;
        }

        .winner-table {
            width: 49%;
        }

        .image-card {
            width: 45% !important;
            margin: 10px;
            border-radius: 10px;
        }

      img {
        width: 600px;
      }
    }

    th {
        text-align: left;
        height: 28px;
        background-color: darkseagreen;
        border:1px solid rgba(0,0,0,0.4);
        box-shadow:1px 1px 1px -1px #000;
    }

    th, td {
        padding: 5px 10px;
    }

    td {
        border:1px solid rgba(0,0,0,0.4);
        box-shadow:-1px -1px 1px -1px #000;
        background-color: aquamarine;
    }

    pre {
        line-height: 1.5;
    }

    .actionBtn {
        display: inline-block;
        float: right;
        margin-left: 7px;
    }

    .actionBtn .v-icon {
        font-size: 18px !important;
    }

    .actionBtn:hover {
        cursor: pointer;
    }
</style>